import api from "@/api";

export default {
  namespaced: true,
  state: {
    user: {
      access: undefined,
      refresh: undefined
    }
  },
  mutations: {
    setAccessToken(state, payload) {
      api.defaults.headers.common['Authorization'] = `Bearer ${payload}`
      state.user.access = payload
    },
    setToken(state, {access, refresh}) {
      api.defaults.headers.common['Authorization'] = `Bearer ${access}`
      state.user.access = access
      state.user.refresh = refresh
    },
    clearToken(state) {
      delete api.defaults.headers.common['Authorization']
      state.user.access = undefined
      state.user.refresh = undefined
    }
  }
}
